/**
 * This method generated a 'random' UUID for the images
 */
const uuidv4 = () => {
  function p8(s) {
    const p = `${Math.random().toString(16)}000000000`.substr(2, 8);
    return s ? `-${p.substr(0, 4)}-${p.substr(4, 4)}` : p;
  }
  return p8() + p8(true) + p8(true) + p8();
};
/**
 * This method retrieves an array of URL's and turn it into
 * objects that the Uploader understands
 * @param {Array} images
 */
const imagesArrayToFiles = (images) => {
  const imageArray = images.map((e) => {
    const tmp = {
      url: e,
      uid: uuidv4(),
      key: e.split('.com/')[1],
      name: e.split('.com/')[1],
      status: 'done',
    };
    return tmp;
  });
  return imageArray;
};

export { imagesArrayToFiles, uuidv4 };
